import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import directive from './directive'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/style/theme.scss';
import '@/assets/style/common.scss';
import './permission'

import Pagination from "@/components/Pagination";
localStorage.setItem('token', 'dev-token')
Vue.component('Pagination', Pagination)

Vue.use(directive)

Vue.use(ElementUI, {
  size: 'medium' 
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
